import { APIModel } from 'app/state/api';
import { ApiCallModel } from 'app/state/api/interfaces';

const changeUserRole: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_AUTH_API}/assign-role`),
};

export default changeUserRole;
